import React from "react";

import { ResourceRequester } from "sulu-admin-bundle/services";

const PassportCell = ({ player, localState }) => {
    const openPassportHandler = (passportId) => {
        localState.open();
        localState.setLoading(true);

        const cached = localState.passportCache[passportId];

        if (cached) {
            localState.open(cached);
            localState.setLoading(false);
            return;
        }

        ResourceRequester.getList("dhbpassports", {
            locale: "de",
            id: passportId,
        })
            .then((data) => {
                if (data) {
                    localState.open(data);
                    localState.setPassportCache(passportId, data);
                }
            })
            .catch((error) => {
                console.log(error);
                localState.open({ error: error.statusText });
            })
            .finally(() => {
                localState.setLoading(false);
            });
    };

    return (
        <div
            style={{
                cursor: "pointer",
                borderBottom: "1px solid black",
            }}
        >
            <span onClick={() => openPassportHandler(player.passport)}>
                {player.passportNumber}
            </span>
        </div>
    );
};

export default PassportCell;
